// extracted by mini-css-extract-plugin
module.exports = {"RemindSuccess":"style_RemindSuccess__1zss8","Title":"style_Title__3WoUV","SubTitle":"style_SubTitle__1_yGp","Button":"style_Button__jSPGX"};